import { t as i } from "../i18n.mjs";
async function u(a) {
  return new Promise((t, o) => {
    const e = new Image();
    e.src = a, e.crossOrigin = "Anonymous", e.onload = () => {
      const n = e.width / e.height;
      t([e, n]);
    }, e.onerror = (n) => {
      o(new Error("Failed to load image"));
    };
  });
}
function m(a, t, o = 0.02) {
  return Math.abs(a - t) < o;
}
function l(a, t = 0.02) {
  const e = [
    { label: "(1:1)", value: 1 },
    { label: "(16:9)", value: 1.7777777777777777 },
    { label: "(21:9)", value: 2.3333333333333335 },
    { label: "(4:3)", value: 1.3333333333333333 },
    { label: "(1.43:1)", value: 1.43 },
    { label: "(32:9)", value: 3.5555555555555554 },
    { label: "(1.41:1)", value: 1.41 },
    { label: "(9:16)", value: 0.5625 },
    { label: "(19.5:9)", value: 2.1666666666666665 },
    { label: "(12:7)", value: 1.7142857142857142 }
  ].find((n) => Math.abs(a - n.value) < t);
  return e == null ? void 0 : e.label;
}
function p(a, t = 0.02) {
  const o = l(a, t);
  let e = i("file_manager.image_cropper.aspect_ratio.need_to_crop");
  return o && (e += ` ${o}`), e;
}
function b(a, t) {
  if (!t || isNaN(t))
    return a;
  const o = l(t);
  if (!o)
    return a;
  const e = o.replace(/[\s:]+/g, "_"), n = a.name.split(".").pop(), r = `${a.name.replace(/\.[^.]+$/, "")}_${e}.${n}`;
  return new File([a], r, {
    type: a.type,
    lastModified: a.lastModified
  });
}
export {
  b as appendAspectRatioToFileName,
  m as areAspectRatiosEqual,
  l as getAspectRatioLabel,
  p as getAspectRatioNote,
  u as getImageAspectRatio
};
